

























































































import VueOptions from '@utils/VueOptions'
import VenueMapSelector from '@ui/VenueMapSelector'

settings =
  name: 'VenueInPersonForm'

  vue:
    props: ['wizard', 'venue']

    components: {
      VenueMapSelector,
    }

    data: ->
      form: @venue

    computed:
      inPersonVenues: ->
        venues = Object.values(@wizard.audienceSetData.venues)
        venues.filter((venue) => venue.in_person and venue.key isnt @venue.key)

      actionsForVenueMapSelector: ->
        select: @selectVenue

      primaryTypeIsCoworking: ->
        @wizard.audienceSetData.pitch.primary_type is 'coworking'

      # mediaKitUrls: -> [
      #   'http://static4.depositphotos.com/1016418/369/i/450/depositphotos_3693820-American-Football-Field.jpg',
      #   'http://www.cinetcetera.com.br/wp-content/uploads/2021/02/climate-change-earth-wakanda-03.jpg',
      #   'https://img.myloview.com.br/posters/katar-700-163086192.jpg',
      # ]

      # contactList: -> [
      #   {
      #     name: 'Amanda Xia'
      #     role: 'Organizer'
      #     contact: 'texasthonpartnership@gmail.com'
      #     checked: false
      #   },
      #   {
      #     name: 'Emily Cohen'
      #     role: 'Adivisor'
      #     contact: 'emily.cohen@austin.utexas.edu'
      #     checked: false
      #   },
      #   {
      #     name: 'Ej Patterson'
      #     role: 'Adivisor'
      #     contact: 'ejpatterson@austin.utexas.edu'
      #     checked: false
      #   },
      #   {
      #     name: 'Grant Daniels'
      #     role: 'Adivisor'
      #     contact: 'grant.daniels@austin.utexas.edu'
      #     checked: true
      #   },
      #   {
      #     name: 'Blue Red'
      #     role: 'Student'
      #     contact: 'test1123@utexas.edu'
      #     checked: true
      #   },
      #   {
      #     name: 'Green Purple'
      #     role: 'Advisor'
      #     contact: 'other@utexas.edu'
      #     checked: true
      #   },
      # ]

    methods:
      selectVenue: (venue) ->
        @form.address = venue.address
        @form.timezone = venue.timezone

export default VueOptions.vue settings
